import React from 'react';
import { motion } from 'framer-motion';
export function FinalPush() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-charcoal-dark border-t border-white/5 relative overflow-hidden" data-id="element-80">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-[0.03]" data-id="element-81" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-82">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-83">
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold mb-8 leading-tight" data-id="element-84">
            En 30 días podrías estar vendiendo… <br data-id="element-85" />
            <span className="text-gold italic font-normal" data-id="element-86">
              o seguir pensando.
            </span>
          </h2>

          <p className="text-xl sm:text-2xl text-cream-muted font-light max-w-2xl mx-auto" data-id="element-87">
            Sin experiencia. Sin inversión grande.{' '}
            <br className="hidden sm:block" data-id="element-88" />
            <span className="font-medium text-cream" data-id="element-89">
              Solo necesitás empezar.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}